<div class="modal-body fs" Id="invoiceId">
    <div class="text-center" *ngIf="isPrintLogo">
    <banner-setting></banner-setting>
        </div>
    <ng-container>
        <div class="row">

            <div class="col-12 overflow-auto fs">

                <table class="invoice-table">
                    <tr>
                        <th class="label">
                            Patient Name
                        </th>
                        <th class="value">
                            <span class="margin-right">: </span>
                            <span class="text-uppercase" [textContent]="registrationBill[0].patientName"></span>
                        </th>
                        <th class="label">
                            Age/Gender
                        </th>
                        <th class="value">
                            <span class="margin-right">: </span>
                            <span [textContent]="registrationBill[0].age || 0"></span>/
                            <span [textContent]="registrationBill[0].gender || '-----'"></span>
                        </th>
                    </tr>
                    <tr>
                        <th class="label">
                            <span> UMR No</span>
                        </th>
                        <th class="value">
                            <span class="margin-right">: </span>
                            <span [textContent]="registrationBill[0].umrNo"></span>
                        </th>
                        <th class="label">
                            <span>Invoice Date</span>
                        </th>
                        <th class="value">
                            <span class="margin-right">: </span>
                            <span [textContent]="registrationBill[0].createdDate | date:'dd/MM/yyyy'"></span>
                        </th>
                    </tr>
                    <tr>
                        <th class="label">
                            <span>Created By</span>
                        </th>
                        <th class="value">
                            <span class="margin-right">: </span>
                            <span [textContent]="registrationBill[0].createdByName"></span>
                        </th>
                        <th class="label">
                            <span>Registration Charge </span>
                        </th>
                        <th class="value">
                            <span class="margin-right">: </span>
                            <span [textContent]="registrationBill[0].total"></span>
                        </th>
                    </tr>

                </table>
            </div>
            <div class="col-12 overflow-auto">
                <table width="100%" class="table table-bordered invoice-table">
                    <tbody>
                        <tr class="table-header">
                            <th class="table-cell">SNo.</th>
                            <th class="table-cell">Service Name</th>
                            <th class="table-cell">Payment Mode</th>
                            <th class="table-cell total-cell">Paid Amount</th>
                        </tr>
                        <tr *ngFor="let register of registrationBill; index as k;">
                            <td class="table-cell">{{k + 1}}</td>
                            <td class="table-cell"><span>Patient Registration Charge</span></td>
                            <td class="table-cell"><span [textContent]="register.payTypeName"></span></td>
                            <td class="table-cell total-cell"><span [textContent]="register.charge | currency: 'INR'"></span></td>
                        </tr>
                        <tr>
                            <td class="table-cell total-label" colspan="3">
                                Total Paid Amount
                            </td>
                            <td class="table-cell total-cell"><span [textContent]="paidAmount | currency: 'INR'"></span></td>
                        </tr>
                        <tr>
                            <td class="table-cell total-label" colspan="3">
                                Due Amount
                            </td>
                            <td class="table-cell total-cell"><span [textContent]="totalAmount | currency: 'INR'"></span></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-12 overflow-auto">
                <table border="0" cellspacing="0" cellpadding="5" class="info-table">
                    <tr>
                        <th class="info-cell">Printed By</th>
                        <th class="info-cell">
                            <span class="margin-right">: </span>
                            <span [textContent]="page.userAccount.fullName"></span>
                        </th>
                    </tr>
                    <tr>
                        <th class="info-cell">Printed Date</th>
                        <th class="info-cell">
                            <span class="margin-right">: </span>
                            <span [textContent]="currentDate | date :'d/MM/yyyy, h:mm a'"></span>
                        </th>
                    </tr>
                </table>
            </div>
        </div>
    </ng-container>
</div>



<!--<div class="row">
    <div class="col-12 overflow-auto" style="margin-bottom: 20px">
        <table width="100%" style="font-size: 22px;">
            <tr>
                <th colspan="4" style="color: #000;padding: 0;text-align: center; vertical-align: middle; font-size: 22px;">
                    <b>Invoice</b>
                </th>
            </tr>
            <tr>
                <th style="padding: 0; text-align: left;color: #000;">
                    Patient Name
                </th>
                <th style="padding: 0;color: #000;">
                    <span style="margin-right: 5px">: </span>
                    <span [textContent]="registrationBill[0].patientName"></span>
                </th>
                <th style="padding: 0; text-align: left;color: #000;">
                    Age/Gender
                </th>
                <th style="padding: 0;color: #000;">
                    <span style="margin-right: 5px">: </span>
                    <span [textContent]="registrationBill[0].age || 0"></span>/
                    <span [textContent]="registrationBill[0].gender || '-----'"></span>
                </th>
            </tr>
            <tr>
                <th style="padding: 0; text-align: left;color: #000;">
                    <span>Invoice Date</span>
                </th>
                <th style="padding: 0;color: #000;">
                    <span style="margin-right: 5px">: </span>
                    <span [textContent]="registrationBill[0].createdDate | date:'dd/MM/yyyy, h:mm a'"></span>
                </th>
                <th style="padding: 0; text-align: left;color: #000;">
                    <span>Created By</span>
                </th>
                <th style="padding: 0;color: #000;">
                    <span style="margin-right: 5px">: </span>
                    <span [textContent]="registrationBill.createdByName"></span>
                </th>
            </tr>
        </table>
    </div>
    <div class="col-12 overflow-auto">
        <table width="100%" style="border-top: 1px solid #000;font-size: 22px" class="table table-bordered">
            <tbody>
                <tr style="font-weight: bold;">
                    <th style="padding: 0; color: #000;">SNo.</th>
                    <th style="padding: 0; color: #000;">Service Name</th>
                    <th style="padding: 0; color: #000;">Payment Mode</th>
                    <th style="text-align: right;padding: 0; color: #000;">Total</th>
                </tr>
                <tr *ngIf="let register of registrationBill">
                    <td style="padding: 0; color: #000;">1</td>
                    <td style="padding: 0; color: #000;"><span>Patient Registration Charge</span></td>
                    <td style="padding: 0; color: #000;"><span [textContent]="register.payTypeName"></span></td>
                    <td style="text-align: right;padding: 0; color: #000;"><span [textContent]="register.charge | currency: 'INR'"></span></td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="col-12 overflow-auto">
        <table border="0" cellspacing="0" cellpadding="5" style="margin-top: 10px; font-size: 22px;">
            <tr>
                <th style="padding: 0; text-align: left;color: #000;" width="200">
                    Printed By
                </th>
                <th style="padding: 0;color: #000;">
                    <span style="margin-right: 5px">: </span>
                    <span [textContent]="page.userAccount.fullName"></span>
                </th>
            </tr>
            <tr>
                <th style="padding: 0; text-align: left;color: #000;" width="200">
                    Printed Date
                </th>
                <th style="padding: 0;color: #000;">
                    <span style="margin-right: 5px">: </span>
                    <span [textContent]="todayDate | date :'d/MM/yyyy, h:mm a'"></span>
                </th>
            </tr>
        </table>
    </div>
</div>-->
